<section>
  <div class="container-fluid wrapper">
    <div #scrollContainer class="container">
      <!-- Upload box section -->
      <div class="row">
        <div id="drop-area">
          <form>
            <p>
              Upload a file by pressing "Upload File" or by dragging and
              dropping an image onto the dashed region
            </p>
            <input
              type="file"
              id="fileElem"
              accept="image/*, application/pdf"
              (change)="handleChange($event)"
              [disabled]="isSubmitting"
            />
            <label class="button" for="fileElem">Upload File</label>
            <mat-error *ngIf="submitAttempted && images?.length == 0">
              Please select a file to upload.
            </mat-error>
          </form>
        </div>
      </div>
      <form (ngSubmit)="onSubmit()" (ngReset)="onReset()">
        <div class="form-wrapper">
          <div id="preview-gallery" class="full-row gallery">
            <button
              id="badge-input"
              *ngIf="previewedFile"
              class="close"
              type="button"
              (click)="removeImage($event)"
              aria-label="Close"
            >
              <span aria-hidden="true">X</span>
            </button>

            <img
              id="previewed-file"
              (click)="handleImageClick()"
              *ngIf="previewedFile"
              [src]="previewedFile"
              height="300"
            />
          </div>
        </div>
        <div class="form-wrapper">
          <div class="tabs">
            <!-- Tabs  -->
            <mat-tab-group
              animationDuration="0ms"
              #tabGroup
              [selectedIndex]="selectedIndex"
              (selectedTabChange)="onTabClick($event)"
            >
              <mat-tab label="Credit Card"></mat-tab>
              <mat-tab label="Cash Reimbursement"></mat-tab>
            </mat-tab-group>
          </div>

          <div
            class="form-row"
            *ngIf="canModifyEmployee"
            (click)="scrollToTop($event.target, 'Employee')"
          >
            <mat-form-field class="full-row" appearance="outline">
              <mat-label>Employee</mat-label>
              <input
                #employeeInput
                matInput
                required
                aria-label="Employee Autocomplete"
                type="text"
                (click)="handleUserFocus()"
                (blur)="handleUserBlur()"
                placeholder="Search Employees..."
                [matAutocomplete]="employeeAuto"
                [formControl]="employeeControl"
              />
              <mat-autocomplete
                #employeeAuto="matAutocomplete"
                (optionSelected)="onSelect($event)"
              >
                <mat-option class="hidden">--</mat-option>
                <mat-option
                  *ngFor="let user of filteredUsers"
                  [value]="getUserLabel(user)"
                >
                  {{ getUserLabel(user) }}
                </mat-option>
              </mat-autocomplete>
              <mat-error
                *ngIf="
                  (employeeControl.touched || submitAttempted) &&
                  employeeControl.hasError('required')
                "
              >
                Invalid employee. Please make a valid selection.
              </mat-error>
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field appearance="outline" class="amt-field">
              <mat-label>{{ getLabel() }}</mat-label>
              <span *ngIf="amount.value != ''" class="currency-symbol">$</span>
              <input
                type="text"
                matInput
                required
                placeholder="Enter amount"
                [formControl]="amount"
                (input)="onAmountChange($event)"
              />
              <mat-error
                *ngIf="
                  amount.value == '' && (amount.touched || submitAttempted)
                "
              >
                Please enter a valid amount
              </mat-error>
            </mat-form-field>

            <mat-form-field id="datepicker-input" appearance="outline">
              <mat-label>Receipt Date</mat-label>
              <input
                matInput
                required
                [matDatepicker]="picker"
                [formControl]="selectedDate"
              />
              <mat-hint>MM/DD/YYYY</mat-hint>
              <mat-datepicker-toggle
                matSuffix
                [for]="picker"
              ></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>

              <mat-error
                *ngIf="submitAttempted && selectedDate.hasError('required')"
              >
                Please choose a receipt date
              </mat-error>
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field
              class="full-row"
              appearance="outline"
              (click)="scrollToTop($event.target, 'Job')"
            >
              <mat-label>Job</mat-label>
              <input
                #jobInput
                matInput
                aria-label="Job Autocomplete"
                type="text"
                (click)="handleJobFocus()"
                (blur)="handleJobBlur()"
                placeholder="Search Job..."
                [matAutocomplete]="jobAuto"
                [formControl]="jobControl"
              />
              <mat-autocomplete
                #jobAuto="matAutocomplete"
                (optionSelected)="onSelect($event)"
                (closed)="handleJobBlur()"
              >
                <mat-option class="hidden">--</mat-option>
                <p
                  class="autocomplete-label"
                  *ngIf="filteredFavoriteJobs.length"
                >
                  MY FAVORITES
                </p>
                <mat-option
                  *ngFor="let job of filteredFavoriteJobs"
                  [value]="getJobLabel(job)"
                >
                  {{ getJobLabel(job) }}
                </mat-option>
                <mat-divider [vertical]="false"></mat-divider>
                <mat-option
                  *ngFor="let job of filteredJobs"
                  [value]="getJobLabel(job)"
                >
                  {{ getJobLabel(job) }}
                </mat-option>
              </mat-autocomplete>
              <mat-error
                *ngIf="
                  (jobControl.touched || submitAttempted) &&
                  jobControl.hasError('invalidSelection')
                "
              >
                Invalid job. Please make a valid selection.
              </mat-error>
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field class="full-row" appearance="outline">
              <mat-label>Expense Category</mat-label>
              <mat-select matInput [formControl]="expenseControl" required>
                <mat-option>--</mat-option>
                <mat-option
                  *ngFor="let category of expenseCategories"
                  [value]="category.name"
                >
                  {{ category.name }}
                </mat-option>
              </mat-select>
              <mat-error
                *ngIf="submitAttempted && expenseControl.hasError('required')"
              >
                Please choose an expense category
              </mat-error>
            </mat-form-field>
          </div>

          <div
            class="form-row"
            *ngIf="canShowMaintFields || canShowFuelFields"
            (click)="scrollToTop($event.target, 'Equipment')"
          >
            <mat-form-field class="full-row" appearance="outline">
              <mat-label>Unit</mat-label>
              <input
                #equipmentInput
                matInput
                required
                aria-label="Equipment (unit) Autocomplete"
                type="text"
                (click)="handleEquipmentFocus()"
                (blur)="handleEquipmentBlur()"
                placeholder="Search Units..."
                [matAutocomplete]="equipAuto"
                [formControl]="equipmentControl"
              />
              <mat-autocomplete
                #equipAuto="matAutocomplete"
                (optionSelected)="onSelect($event)"
                (closed)="handleEquipmentBlur()"
              >
                <mat-option class="hidden">--</mat-option>
                <p
                  class="autocomplete-label"
                  *ngIf="filteredFavoriteEquipments.length"
                >
                  MY FAVORITES
                </p>
                <mat-option
                  *ngFor="let unit of filteredFavoriteEquipments"
                  [value]="getEquipmentLabel(unit)"
                >
                  {{ getEquipmentLabel(unit) }}
                </mat-option>
                <mat-divider [vertical]="false"></mat-divider>
                <mat-option
                  *ngFor="let unit of filteredEquipments"
                  [value]="getEquipmentLabel(unit)"
                >
                  {{ getEquipmentLabel(unit) }}
                </mat-option>
              </mat-autocomplete>
              <mat-error
                *ngIf="submitAttempted && equipmentControl.hasError('required')"
              >
                Please choose a unit
              </mat-error>
              <mat-error
                *ngIf="
                  (equipmentControl.touched || submitAttempted) &&
                  equipmentControl.hasError('invalidSelection')
                "
              >
                Invalid unit. Please make a valid selection.
              </mat-error>
            </mat-form-field>

            <!-- Un/Favorite icon button-->
            <div id="favorite-container" *ngIf="equipmentControl.value">
              <button
                mat-flat-button
                type="button"
                (click)="onFavoritePress($event)"
              >
                <span><i [ngClass]="setFavoriteIconColor()"></i></span>
                <span>{{ getFavoriteLabel() }}</span>
              </button>
            </div>
          </div>

          <div class="form-row" *ngIf="canShowFuelFields">
            <mat-form-field appearance="outline">
              <mat-label>Mileage</mat-label>
              <input
                matInput
                required
                type="text"
                placeholder="Enter mileage"
                [formControl]="mileage"
                (input)="onMileageChange($event)"
              />
              <mat-error
                *ngIf="submitAttempted && mileage.hasError('required')"
              >
                Please enter mileage amount
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Gallons</mat-label>
              <input
                matInput
                required
                type="text"
                inputmode="decimal"
                placeholder="Enter gallons"
                [formControl]="gallons"
                (input)="onGallonsChange($event)"
              />
              <mat-error
                *ngIf="submitAttempted && gallons.hasError('required')"
              >
                Please enter gallons amount
              </mat-error>
            </mat-form-field>
          </div>

          <div class="form-row" *ngIf="canShowLodgingFields">
            <mat-form-field appearance="outline">
              <mat-label>Nights</mat-label>
              <input
                matInput
                required
                type="text"
                inputmode="numeric"
                placeholder="Enter number of nights"
                [formControl]="nights"
                (input)="onNightsChange($event)"
              />
              <mat-error *ngIf="submitAttempted && nights.hasError('required')">
                Please enter the number of nights
              </mat-error>
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field class="full" appearance="outline">
              <mat-label>Notes</mat-label>
              <textarea
                class="full"
                matInput
                placeholder="Comments about this receipt"
                [formControl]="notes"
                [attr.maxlength]="maxCharLimit"
                (input)="updateCharCount()"
              ></textarea>
              <mat-error *ngIf="submitAttempted && notes.hasError('required')">
                A note is required when 'Other' is selected in the Unit dropdown
              </mat-error>
              <!-- Character count and limit -->
              <div
                class="char-count"
                [ngClass]="{ warning: notesCharCount >= maxCharLimit - 15 }"
              >
                <span>{{ notesCharCount }}/{{ maxCharLimit }}</span>
              </div>
            </mat-form-field>
          </div>

          <div class="form-row">
            <button
              class="submit-button"
              [disabled]="isSubmitting"
              type="submit"
            >
              Submit
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</section>

<div class="spinner-container">
  <ngx-spinner
    bdColor="rgba(51,51,51,0.8)"
    size="medium"
    color="#fff"
    type="ball-scale-multiple"
  >
    <p style="font-size: 20px; color: white">Loading...</p>
  </ngx-spinner>
</div>

<div *ngIf="loading$ | async" class="spinner-container">
  <mat-progress-spinner
    style="
      left: 10rem;
      bottom: 0;
      top: 25rem;
      position: fixed;
      z-index: 999999;
      display: flex;
      width: 100px;
      height: 100px;
    "
    mode="indeterminate"
  ></mat-progress-spinner>
</div>
